/* tslint:disable */
/* eslint-disable */
/**
 * deliveryProviderPortal delivery-provider api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const ProviderLifecycleStatus = {
        READY_FOR_WORK: 'ready_for_work',
        HIDDEN: 'hidden',
        ONBOARDING: 'onboarding',
        ARCHIVED: 'deleted'
} as const;
export type ProviderLifecycleStatus = typeof ProviderLifecycleStatus[keyof typeof ProviderLifecycleStatus];

